import React, { useEffect, useMemo, useState } from 'react';
import { Box, Grid2, Container, Button, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getFilteredSalesByTypeReport } from '../../features/StockReports/salesByTypeSlice';
import Navbar from '../setup/Navbar';
import StickyHeadTable from '../../BuiltInComponent/TableWithPagination';
import HeadingText from '../../BuiltInComponent/HeadingTest';

const SalesByTypeReport = () => {
    const dispatch = useDispatch();
    const { reportData } = useSelector((state) => state.sbt);
    const getTodayDate = () => new Date().toISOString().split('T')[0];
    const [dateRange, setDateRange] = useState({ fromDate: getTodayDate(), toDate: getTodayDate() });

    useEffect(() => {
        dispatch(getFilteredSalesByTypeReport({ fromDate: getTodayDate(), toDate: getTodayDate() }));
    }, [dispatch]);

    const handleDateChange = (event) => {
        const { name, value } = event.target;
        setDateRange((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleGenerateReport = () => {
        dispatch(getFilteredSalesByTypeReport({
            fromDate: dateRange.fromDate,
            toDate: dateRange.toDate
        }));
    };

    const totals = useMemo(() => {
        if (!reportData || reportData.length === 0) return { amount: 0, orders: 0 };
        return reportData.reduce((sum, item) => {
            return {
                amount: sum.amount + Number(item.totalAmount || 0),
                orders: sum.orders + Number(item.orderCount || 0)
            };
        }, { amount: 0, orders: 0 });
    }, [reportData]);

    const tableData = useMemo(() => {
        if (!reportData || reportData.length === 0) return [];
        const rows = reportData.map((item, index) => ({
            rowNo: index + 1,
            ...item
        }));

        rows.push({
            rowNo: rows.length + 1,
            userName: 'TOTAL',
            saleType: 'All',
            orderCount: totals.orders,
            totalAmount: totals.amount
        });

        return rows;
    }, [reportData, totals]);

    return (
        <>
            <Navbar />
            <Container>
                <Box sx={{ p: 2 }}>
                    <HeadingText text="Sales By Type Report" />
                    <Box component="form" sx={{ flexGrow: 1, mt: 3 }}>
                        <Grid2 container spacing={2}>
                            <Grid2 size={4}>
                                <TextField
                                    fullWidth
                                    label="Date From"
                                    type="date"
                                    name="fromDate"
                                    value={dateRange.fromDate}
                                    onChange={handleDateChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid2>
                            <Grid2 size={4}>
                                <TextField
                                    fullWidth
                                    label="Date To"
                                    type="date"
                                    name="toDate"
                                    value={dateRange.toDate}
                                    onChange={handleDateChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid2>
                            <Grid2 size={4}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    fullWidth
                                    onClick={handleGenerateReport}
                                >
                                    Generate Report
                                </Button>
                            </Grid2>
                            <Grid2 size={12}>
                                <StickyHeadTable
                                    tableColumns={[
                                        { fieldName: 'rowNo', cName: 'Row', textAlign: 'left', width: 40, status: 'dis', dType: 'number' },
                                        { fieldName: 'userName', cName: 'User', textAlign: 'left', width: 140, status: 'en', dType: 'string' },
                                        { fieldName: 'saleType', cName: 'Sale Type', textAlign: 'left', width: 120, status: 'en', dType: 'string' },
                                        { fieldName: 'orderCount', cName: 'Orders', textAlign: 'right', width: 80, status: 'en', dType: 'number' },
                                        { fieldName: 'totalAmount', cName: 'Amount', textAlign: 'right', width: 100, status: 'en', dType: 'number' },
                                        { fieldName: 'Edit', cName: 'Edit', textAlign: 'right', width: 80, status: 'dis', dType: 'string' },
                                        { fieldName: 'Delete', cName: 'Delete', textAlign: 'center', width: 80, status: 'dis', dType: 'string' },
                                        { fieldName: 'Extra', cName: 'Extra', textAlign: 'center', width: 80, status: 'dis', dType: 'string' }
                                    ]}
                                    tableData={tableData}
                                    perPage={5}
                                    paginationStatus={false}
                                    textForTotal={'Total Amount'}
                                    total={totals.amount}
                                />
                            </Grid2>
                        </Grid2>
                    </Box>
                </Box>
            </Container>
        </>

    );
};

export default SalesByTypeReport;
